import dayjs from 'dayjs';
const quarterOfYear = require('dayjs/plugin/quarterOfYear');
dayjs.extend(quarterOfYear);

// RangePicker
export function disableAntdPickerDates( current ) {
    // Can not select days after today
    return current && current > dayjs().endOf('day');
}